import React from "react";
import avatar from "@/assets/mira-avatar.jpg";

// Mira's headshot — used beside her chat messages and in the empty state.
export function MiraAvatar({ className = "h-8 w-8" }) {
  return (
    <img
      src={avatar}
      alt="Mira"
      data-testid="mira-avatar"
      className={`${className} rounded-full object-cover object-top border border-emerald-500/40 shrink-0`}
    />
  );
}
